















import Vue from 'vue'
import LanguageSelector from '@/components/Dashboard/LanguageSelector.vue'

export default Vue.extend({
  components: {
    appLanguageSelector: LanguageSelector,
  },
  data() {
    return {
      language: 'es',
      firstTime: false,
    }
  },
  watch: {
    async language(value: string): Promise<void> {
      this.$i18n.locale = value
      this.$vuetify.lang.current = value
    },
  },
  methods: {
    onNextLogin(firstTime: boolean) {
      this.firstTime = firstTime
    },
  },
})
